import {useMutation} from "@tanstack/react-query";
import {removeExpedientNoteMutationOptions} from "./remove-expedient-note.mutation-options";

export function useRemoveExpedientNote(id: string) {
  return useMutation(removeExpedientNoteMutationOptions(id));
}
